export default "__VITE_ASSET__BaGWjyJ___"